import React from 'react';
import PropTypes from 'prop-types';

import {Button} from '@stubhub/bamboo';

import '../styles/index.scss';

/**
 * Button to show current store and open modal to change it
 */
const StoreSelector = ({countryCode, countryName, onClick}) => {
  const classnames = countryCode && countryCode.length > 0 ? `flag-${countryCode}` : '';
  const leftIcon = <span className={`store-selector__country ${classnames}`} />;

  return (
    <Button type="button" appearance="secondary" className="store-selector" onClick={onClick} leftIcon={leftIcon}>
      {countryName}
    </Button>
  );
};

StoreSelector.propTypes = {
  /**
   * Actual country code, to print the flag
   */
  countryCode: PropTypes.string.isRequired,

  /**
   * Actual country name
   */
  countryName: PropTypes.string.isRequired,

  /**
   * Function to invoke on button clicked
   */
  onClick: PropTypes.func.isRequired,
};

export default StoreSelector;
